
import React, { useState, useEffect } from "react";
import { postData } from "../../../../../ApiServices/ApiService";
import { ORG_CONFIGURATION_TEMPLETE_LIST } from "../../../../../ApiServices/BaseURL";
import { logFrontendException } from "../../../../../Utils/Exception";
import { useTheme } from "../../../../../GlobalContext/GlobalContext";

const WhatsAppTemplateListController = (data, loading, error, refreshHandlers) => {
    const [filterData, setFilterData] = useState({
        templateName: "",
        createdBy: "",
        createdDate: "",
    });

    const [whatsAppTemplateData, setWhatsAppTemplateData] = useState([]);
    const [filterLoading, setFilterLoading] = useState(false);
    const [filterError, setFilterError] = useState('');

    const [filterSelectionError, setFilterSelectionError] = useState('');
    const [showFilters, setShowFilters] = useState(false);

    const { setIsLoginPopup } = useTheme();

    const [expandedRows, setExpandedRows] = useState({});
    const toggleExpand = (key) => {
        setExpandedRows((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };

    const handleInputChange = (field, value) => {
        setFilterData((prevData) => ({
            ...prevData,
            [field]: value,
        }));
    };

    useEffect(() => {
        if (data) {
            setWhatsAppTemplateData(data);
        }
        setFilterError(error);
        setFilterLoading(loading);
    }, [data, error, loading]);

    const pageName = "WhatsAppTemplateListController";

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const totalPages = Math.ceil(whatsAppTemplateData?.length / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentTasks = whatsAppTemplateData?.slice(indexOfFirstItem, indexOfLastItem);

    const handlePageChange = (pageNumber) => {
        if (pageNumber > 0 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    const maxVisiblePages = 3;

    const getVisiblePages = () => {
        const startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
        const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

        // Adjust startPage if we're near the end
        const adjustedStartPage = Math.max(1, endPage - maxVisiblePages + 1);

        return Array.from({ length: endPage - adjustedStartPage + 1 }, (_, index) => adjustedStartPage + index);
    };

    const visiblePages = getVisiblePages();

    const fetchWhatappTemplateFilter = async () => {
        setFilterError('');
        setFilterSelectionError('');
        setExpandedRows({});
        if (!(filterData?.templateName.trim() || filterData?.createdBy || filterData?.createdDate)) {
            setFilterSelectionError('Please enter/select any one of the above');
            return;
        }
        setFilterLoading(true);
        setWhatsAppTemplateData([]);
        setCurrentPage(1);

        const storedUser = JSON.parse(localStorage.getItem("_userInfo_"));

        try {
            const payload = {
                channel_name: 'whatsapp',
                emp_id_auth: storedUser?.emp_id,
                template_name: filterData?.templateName,
                created_by: filterData?.createdBy,
                created_at: filterData?.createdDate,
            };

            const response = await postData(ORG_CONFIGURATION_TEMPLETE_LIST, payload);
            const responseData = await response.json();

            if (response?.status === 200) {
                if (responseData?.status_code === 200) {
                    if (responseData?.message?.toLowerCase() === "success") {
                        if (responseData?.dataJ?.length > 0) {
                            setWhatsAppTemplateData(responseData?.dataJ);
                        } else {
                            setFilterError(responseData?.info || "No templates are available.");
                            logFrontendException(storedUser?.emp_id, pageName, 'fetchWhatappTemplateFilter', responseData?.info);
                        }
                    } else {
                        setFilterError(responseData?.info || "Failed to fetch templates.");
                        logFrontendException(storedUser?.emp_id, pageName, 'fetchWhatappTemplateFilter', responseData?.info);
                    }
                } else {
                    setFilterError(responseData?.info || "Unable to fetch templates.Please try again later.");
                    logFrontendException(storedUser?.emp_id, pageName, 'fetchWhatappTemplateFilter', responseData);
                }
            } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                setFilterError('Unauthorized access. Your session may have expired. Please log in again.');
                setIsLoginPopup(true)
                logFrontendException(storedUser?.emp_id, pageName, 'fetchWhatappTemplateFilter', response || '');
            } else {
                setFilterError("Failed to fetch templates.Please try again.");
                logFrontendException(storedUser?.emp_id, pageName, 'fetchWhatappTemplateFilter', response || '');
            }
        } catch (err) {
            setFilterError("Unable to fetch templates.Please check your internet connection and try again.");
            logFrontendException(storedUser?.emp_id, pageName, 'fetchWhatappTemplateFilter', err);
        } finally {
            setFilterLoading(false);
        }
    };

    const toggleFilters = () => {
        setShowFilters((prev) => !prev); // Toggle the filter visibility
    };

    const resetFilters = () => {
        if (filterData?.templateName || filterData?.createdBy || filterData?.createdDate) {
            setWhatsAppTemplateData([]);
            setCurrentPage(1);
            setFilterError('');
            refreshHandlers?.whatsapp?.();
        }
        setFilterSelectionError('');
        setFilterData({
            templateName: "",
            createdBy: "",
            createdDate: "",
        });
        setExpandedRows({});
    };

    const cancelFilters = () => {
        resetFilters();
        setShowFilters(!showFilters);
    }

    return {
        whatsAppTemplateData: currentTasks,
        filterData,
        setFilterData,
        handleInputChange,
        filterLoading,
        filterError,
        currentPage,
        totalPages,
        handlePageChange,
        visiblePages,
        fetchWhatappTemplateFilter,
        resetFilters,
        cancelFilters,
        showFilters,
        toggleFilters,
        filterSelectionError,
        expandedRows,
        toggleExpand,
        setExpandedRows,
    }

}

export default WhatsAppTemplateListController